module.exports = __webpack_public_path__ + "img/loading.2088f851.gif";